import { render, staticRenderFns } from "./LanguageSelector.vue?vue&type=template&id=445b9807&"
import script from "./LanguageSelector.vue?vue&type=script&lang=js&"
export * from "./LanguageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/fiksucity/city-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('445b9807')) {
      api.createRecord('445b9807', component.options)
    } else {
      api.reload('445b9807', component.options)
    }
    module.hot.accept("./LanguageSelector.vue?vue&type=template&id=445b9807&", function () {
      api.rerender('445b9807', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LanguageSelector.vue"
export default component.exports